import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2 d-none" }, "Pro", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7 d-none"
}, "max@kt.com", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.$store.state.uid > 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              this.$router.push({name: 'user', params: { uid: _ctx.$store.state.uid, type: 'single', page: 1 }})
            )),
                class: "cursor-pointer",
                src: _ctx.profileUrl,
                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.imageLoadError && _ctx.imageLoadError(...args)))
              }, null, 40, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "fw-bolder d-flex align-items-center fs-5 cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (
              this.$router.push({name: 'user', params: { uid: _ctx.$store.state.uid, type: 'single', page: 1 }})
            ))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$store.state.username) + " ", 1),
            _hoisted_7
          ]),
          _hoisted_8
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("a", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (this.$router.replace({ name: 'logout' }))),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.$t("logout")), 1)
    ])
  ]))
}